import axios from "../http";

let module = "/achievement";

function getAchievement(data) {
    return axios.post(module, data);
}

function studentLine(data) {
    return axios.post(module+"/studentLine", data);
}

function importScore(data) {
    return axios.post(module+"/importScore/"+data.fileId+"/"+data.examId);
}

function barChat(data) {
    return axios.post(module+"/barChat/"+data.classId);
}

    function exportTemplate(data) {
        return axios.get(module+"/exportScore/"+data.classId,{
            responseType: 'blob'
        });
    }

function updateAchievement(data) {
    return axios.put(module, data);
}

function insertAchievement(data) {
    return axios.post(module+"/insert", data);
}

export default {
    getAchievement,
    studentLine,
    importScore,
    barChat,
    exportTemplate,
    updateAchievement,
    insertAchievement,
}
